/**
 * 公共组件的服务 包括提交结果的toast显示，提交成功的model显示
 */

import { Injectable } from "@angular/core";
import {
  LoadingController,
  ModalController,
  Loading,
  Modal,
} from "ionic-angular";
import { GlobalState } from "../../../services/common";

@Injectable()
export class SaveToastService {
  constructor(
    private loadCtrl: LoadingController,
    private modalCtrl: ModalController,
    private global: GlobalState,
  ) {}

  showToast(
    types: "suc" | "fai" | "noNet" | "sysErr",
    msg: string = "",
    during = 2000,
  ): Loading {
    let icon = "";
    let title = "";
    switch (types) {
      case "suc":
        icon = "right.png";
        title = "保存成功";
        break;
      case "fai":
        icon = "wrong.png";
        title = "保存失败";
        break;
      case "noNet":
        icon = "nanguo.png";
        title = "网络不给力";
        break;
      case "sysErr":
        icon = "nanguo.png";
        title = "系统繁忙";
        break;
      default:
        icon = "wrong.png";
        title = "error type";
        break;
    }
    if (msg !== "") {
      title = msg;
    }
    let template =
      `
        <div class="save-toast-label">
        <div> <img class="save-toast-img" src="assets/imgs/` +
      icon +
      `"></div>
        <div class="save-toast-fonts">` +
      title +
      `</div>
      </div>`;

    const loading = this.loadCtrl.create({
      spinner: "hide",
      content: template,
      cssClass: "save-toast-backdrop-bg",
      duration: during,
    });

    loading.present();

    return loading;
  }

  showModal(): Modal {
    let profileModal = this.modalCtrl.create(
      "SucPage",
      { during: 3000 },
      { cssClass: this.global.state.theme },
    );
    profileModal.present();
    return profileModal;
  }

  /**
   * 展示成功页面
   * @param item 数据源
   * @param isApply 是否申请单
   */
  showTravelModal(item, isApply = false): Modal {
    let profileModal = this.modalCtrl.create(
      "SucPage",
      { isApply: isApply, datasource: item, during: 2000 },
      { cssClass: this.global.state.theme },
    );
    profileModal.present();
    return profileModal;
  }
}



// WEBPACK FOOTER //
// ./src/services/common/toast/save-toast.service.ts